import './bootstrap'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import mainStore from './store'
import { VueTables, ServerTable, ClientTable, Event } from 'vue-tables-2';
import VueToastr from '@deveodk/vue-toastr'
import { Pagination } from 'vue-pagination-2';
import VueInputMask from "vue-inputmask"
import money from 'v-money'
import ImageUploader from 'vue-image-upload-resize'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import ToggleButton from 'vue-js-toggle-button'

import { Datetime } from 'vue-datetime'
import { Settings } from 'luxon'

import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBni4q53Pz1X6zwWqQznhNRg2-79ajar6E',
        libraries: 'places', // Required for Places Autocomplete
        // OR: libraries: 'places,drawing'
        // OR: libraries: 'places,drawing,visualization'
        // (as you require)

        //// If you want to set the version, you can do so:
        // v: '3.26',
    },

    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
})

Settings.defaultLocale = 'pt-br'

Vue.use(ImageUploader);
Vue.use(VueInputMask.default);
Vue.use(money, { precision: 2 })
Vue.use(Datetime)
Vue.use(ToggleButton)
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.component('datetime', Datetime)

const translation = {
    count: 'Mostrando {from} de {to} até {count} de registros',
    filter: 'Pesquisar:',
    filterPlaceholder: 'Pesquisar',
    limit: 'Registros:',
    noResults: 'Nenhum registro encontrado',
    page: 'Página:',
    filterBy: 'Filtrar por {column}',
    // for dropdown pagination filterBy: 'Filter by {column}',
    // Placeholder for search fields when filtering by column loading:'Loading...',
    // First request to server defaultOption:'Select {column}'
    // default option for list filters }
}

const options = {
    requestFunction: function (data) {
        // data.token = this.$store.getters.token
        return axios.get(this.url, {
            params: data
        }).catch(function (e) {
            this.dispatch('error', e);
            router.push('/login')
        }.bind(this));
    },
    texts: translation,
    pagination: { chunk: 15, dropdown: false, nav: 'scroll' },
    perPage: 10,
    perPageValues: [10, 25, 50, 100],
    sortIcon: { base: 'fas', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort' }
}

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(router)
Vue.use(ServerTable, options, false, 'bootstrap3', 'footerPagination')
Vue.use(VueToastr)

export const store = new Vuex.Store(mainStore);

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
    created() {
        this.$store.dispatch('initialize')
    },
});

/*
  <link rel="stylesheet" href="src/assets/auxiliary/bootstrap/css/bootstrap.min.css">
    <link rel="stylesheet" href="src/assets/css/style.css">
    <link rel="stylesheet" href="src/assets/auxiliary/animate/animate.css">
    <link rel="stylesheet" href="src/assets/auxiliary/fontawesome/css/all.min.css">    
*/

import './assets/auxiliary/bootstrap/css/bootstrap.css'
import '../node_modules/@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import './assets/css/bootstrap_icons.css'
import './assets/css/style_template.css'
// import './assets/css/style.css'
import './assets/auxiliary/animate/animate.css'
import './assets/auxiliary/chosen/chosen.min.js'
import './assets/auxiliary/chartjs/Chart.min.js'
import './assets/auxiliary/chartjs/utils.js'
import './assets/auxiliary/fontawesome/css/all.min.css'
import './assets/js/plugins/metisMenu/jquery.metisMenu'
import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css'
import '../node_modules/mixitup/dist/mixitup.min.js'
import '../node_modules/vue-select/dist/vue-select.css';
import '../node_modules/moment/moment'
import 'vue-datetime/dist/vue-datetime.css'
import Lightbox from 'vue-easy-lightbox'

Vue.use(Lightbox)

window.moment = require('moment');
moment.locale('pt-br');


import swal from 'sweetalert'

var filter = function (text, length, clamp) {
    clamp = clamp || '...';
    var node = document.createElement('div');
    node.innerHTML = text;
    var content = node.textContent;
    return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

Vue.prototype.$http = window.axios;
Vue.prototype.$message = function (title, msg, type) {

    let newMsg = '';
    if (msg instanceof Object) {

        newMsg += "<ul>";
        for (var key in msg) {
            if (msg.hasOwnProperty(key)) {
                newMsg += "<li>";
                newMsg += msg[key];
                newMsg += "</li>";
            }
        }
        newMsg += "</ul>";

    } else newMsg = msg;

    this.$toastr('add',
        {
            title: title,
            msg: newMsg,
            clickClose: true,
            timeout: 4000,
            position: 'toast-top-right',
            type: type
        })
};

Vue.prototype.$error = function (error) {
    let errors = (error.response) ? error.response.data : error;

    if (typeof errors === 'object') {
        let html = '<ul>';

        $.each(errors, function (key, value) {
            html += '<li>' + value[0] + '</li>';
        });

        html += '</ul>';

        errors = html;
    }

    this.$message(null, errors, 'error');
};


// WEBPACK FOOTER //
// ./src/main.js